module.exports = __webpack_public_path__ + "b237fadd6d2c1b2c3bd2d5e50f2d06a4.pdf";